import { render, staticRenderFns } from "./NavPrevIcon.vue?vue&type=template&id=62d466de"
import script from "./NavPrevIcon.vue?vue&type=script&lang=js"
export * from "./NavPrevIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports